import { Component, HostListener, Injector, OnInit, ViewChild, inject } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import {
  AmdocsAppInitService, AmdocsAuthService,
  AmdocsCookieService, AmdocsUserService
} from 'amdocs-auth-package';
import {
  AMDOCS_CONSTANTS,
  AmdocsDeviceService,
  AmdocsEventBusService,
  AmdocsPwaService,
  AmdocsUserNotifyAlertComponent
} from 'amdocs-core-package';
import { CookieService } from 'ngx-cookie-service';
import { Subscription, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { CONSTANTS } from './constants';
import * as AmdocsConstants from './content.constants';
import { ApiService } from './core/api.service';
import { PwaService } from './core/pwa.service';
import { ToastService } from './feature/ping/services/toast.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  @ViewChild('userNotifyAlert') userNotifyAlert: AmdocsUserNotifyAlertComponent;

  public allowMimic = environment.allowMimic;
  public showLoaderCount = 0;
  public show401ErrorPopup = false;
  public refreshCoolDown = false;
  public debugApiErrors: any[] = [];
  public onBoardingClosed: boolean;
  public showLotteryPopup = false;
  public showLearningPopup = false;
  public showPWAiosNotifications: boolean;
  public skipOnBoarding: boolean =false;
  public href:any;
  public path:any;
  public showMaintenancePopup = false;
  public maintenanceSession : boolean = false;
  private routerSubscription: Subscription;
  cookieServices: AmdocsCookieService;
  public appLoaded: boolean = false;
  public amdocsContentConstants = AmdocsConstants;
  private appInitService: AmdocsAppInitService;
  private pwaService: PwaService;
  private amdocsAuthService: AmdocsAuthService;
  private amdocsUserService: AmdocsUserService;
  private amdocsPwaService: AmdocsPwaService;
  private eventBusService: AmdocsEventBusService;
  private deviceService: AmdocsDeviceService;
  private cookieService: CookieService;
  private apiService: ApiService;
  private router: Router;
  private injector: Injector;
  installPromptEvent: any;
  public toasterService: ToastService = inject(ToastService);
  @HostListener('window:visibilitychange', ['$event'])
  visibilityChange(event): void {
    if (document.visibilityState === CONSTANTS.DOCUMENT_VISIBILITY_STATE_VISIBLE) {
      if (!this.amdocsAuthService.isLoggedIn()) {
        window.location.reload();
      }
    }
  }

  constructor() {
    this.appInitService = inject(AmdocsAppInitService);
    this.pwaService = inject(PwaService);
    this.amdocsAuthService = inject(AmdocsAuthService);
    this.amdocsUserService = inject(AmdocsUserService);
    this.amdocsPwaService = inject(AmdocsPwaService);
    this.eventBusService = inject(AmdocsEventBusService);
    this.deviceService = inject(AmdocsDeviceService);
    this.cookieService = inject(CookieService);
    this.apiService = inject(ApiService);
    this.router = inject(Router);
    this.injector = inject(Injector);
  }

  private beforeInstallPromptHandler = (event: any) => {
  event.preventDefault();
  this.installPromptEvent = event;
};
ngOnInit(): void {
  this.setupInstallPrompt();
  this.handleFirstRun();
  this.subscribeRouterEvents();
  this.subscribeApiErrorEvents();
  this.handleAppDownloadStatus();
  this.subscribeLoaderEvents();
  this.subscribeUserAlertEvents();
  this.handleOnBoardingStatus();
  this.subscribeShowOnBoardingEvents();
  this.showPWAiosNotifications = !this.showOnBoarding;
  this.showMaintenancePopup = this.showMaintenancePopUpCondition;
  this.normalizeOrigPath();
  this.setSkipOnBoarding();
  this.checkIfAppUpdated();
}

private setupInstallPrompt() {
  window.addEventListener('beforeinstallprompt', this.beforeInstallPromptHandler);
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    this.installPromptEvent = event;
  });
}

private handleFirstRun() {
  const firstRun = sessionStorage.getItem('firstRun');
  if (!firstRun) {
    this.maintenanceSession = true;
    sessionStorage.setItem('firstRun', 'no');
  }
}

private subscribeRouterEvents() {
  this.routerSubscription = this.router.events.subscribe((event: Event) => {
    this.handleRouterEvents(event);
  });
}

private subscribeApiErrorEvents() {
  this.eventBusService.on(AMDOCS_CONSTANTS.API_ERROR_EVENT, (error) => {
    this.handleApiError(error);
  }, true);
}

private handleApiError(error: any) {
  if (error.code === 401 && !this.refreshCoolDown) {
    if (this.amdocsAuthService.isLoggedIn()) {
      this.refreshCoolDown = true;
      setTimeout(() => { this.refreshCoolDown = false; }, 30000);
      this.amdocsAuthService.callRefreshUserToken().pipe(
        map(() => {
          this.eventBusService.emit(CONSTANTS.EVENTS.HOMEPAGE_RELOAD_DATA);
        }),
        catchError((refreshError) => {
          this.show401ErrorPopup = true;
          return throwError(() => refreshError);
        })
      ).subscribe();
    } else {
      this.show401ErrorPopup = true;
    }
  }
}

private handleAppDownloadStatus() {
  if (
    this.amdocsAuthService.isLoggedIn() &&
    this.amdocsPwaService.isPwa() &&
    !this.amdocsUserService?.user?.userProfile?.appDownloaded
  ) {
    this.showLotteryPopup = false;
    this.apiService.updateUserAppDownloadStatus(true).subscribe();
  }
}

private subscribeLoaderEvents() {
  this.eventBusService.on(CONSTANTS.EVENTS.TOGGLE_FULL_PAGE_LOADER, (showLoader) => {
    if (showLoader) {
      this.showLoaderCount++;
    } else if (this.showLoaderCount > 0) {
      this.showLoaderCount--;
    }
  }, true);
}

private subscribeUserAlertEvents() {
  this.eventBusService.on(CONSTANTS.EVENTS.NOTIFY_USER_ALERT, (data: { text: string }) => {
    this.userNotifyAlert.showMessage(data.text);
  }, true);
}

private handleOnBoardingStatus() {
  this.onBoardingClosed = !!localStorage.getItem('on-boarding-closed');
}

private subscribeShowOnBoardingEvents() {
  this.eventBusService.on(CONSTANTS.EVENTS.SHOW_ON_BOARDING, () => {
    this.onBoardingClosed = !!localStorage.getItem('on-boarding-closed');
  }, true);
}

private normalizeOrigPath() {
  const origPath = sessionStorage.getItem('orig-path');
  if (
    origPath &&
    (origPath === '/chat' ||
      origPath.includes('/?code') ||
      origPath.includes('/_callback?code'))
  ) {
    sessionStorage.setItem('orig-path', '/');
  }
  this.path = sessionStorage.getItem('orig-path');
}

private setSkipOnBoarding() {
  this.skipOnBoarding = !!(this.path && this.path !== '/');
}

  // Call this method when you want to show the prompt (e.g., on a button click)
showInstallPrompt() {
  if (this.installPromptEvent) {
    this.installPromptEvent.prompt();
    this.installPromptEvent.userChoice.then((result: any) => {
      this.installPromptEvent = null;
    });
  }
}
  private handleRouterEvents(event: Event): void {
    if (event instanceof NavigationStart) {
      this.handleNavigationStart(event);
    }
  }

  private handleNavigationStart(event: NavigationStart): void {
    if (!this.cookieService.get('loginCallbackUrl')) {
     this.cookieService.set('loginCallbackUrl', event.url);
    }

  }

 get appFinishedLoaded(): boolean {
    return this.appInitService.appFinishedLoaded;
  }

  get appError(): boolean {
    return this.appInitService.appInitError !== null && this.appInitService.appInitError !== undefined;
  }

  get showOnBoarding(): boolean {
    return this.appFinishedLoaded && !this.appError && !this.onBoardingClosed;
  }

  get showLearning(): boolean {
     // To enable future logic, uncomment the line below and remove 'return false;'
  // return this.appFinishedLoaded && !this.appError && this.onBoardingClosed && this.amdocsAuthService.isLoggedIn();
  return false;

  }

  get showMaintenancePopUpCondition(): boolean {
    // To enable future logic, uncomment the line below and remove 'return false;'
    // return this.appFinishedLoaded && !this.appError && this.onBoardingClosed && this.maintenanceSession && this.amdocsAuthService.isLoggedIn();
    return false;

  }

  error401popupClick(): void {
    window.location.reload();
  }

  skip(): void {
    this.onBoardingClosed = true;
    localStorage.setItem('on-boarding-closed', '1');
    setTimeout(() => {
      this.showPWAiosNotifications = true;
    }, 10);
  }

  goHome(): void {
    this.router.navigate([''], { replaceUrl: true });
  }
  private checkIfAppUpdated() {
        if (localStorage.getItem('cleanUrl')) {
    window.history.replaceState({}, document.title, window.location.pathname);
    localStorage.removeItem('cleanUrl');
  }
    this.pwaService.$isAnyNewUpdateAvailable.subscribe((versionAvailable: boolean) => {
      if (versionAvailable) {
      this.eventBusService.emit(CONSTANTS.EVENTS.SHOW_NEW_VERSION_ALERT);
      }
    });
  }

}
